import React from 'react';
import {NavLink} from 'react-router-dom';
import '../../../CSS/Dashboard/nav.scss';
import {MdSettings} from 'react-icons/md';
import {FiLogOut} from 'react-icons/fi';
import Swal from 'sweetalert2';
const DashboardNavbar = ()=> {
    const logOut = async()=>{
        const result = await Swal.fire({
            title: `Are you sure to logout?`,
            showDenyButton: true,
            denyButtonText: `Stay`,
            denyButtonColor: '#00c851',
            confirmButtonText: `Sign Out`,
            confirmButtonColor: '#ea5455',
          });
        //   console.log(result);
        if(result.isConfirmed) {
            localStorage.clear();
            window.location.pathname = "/";
        }
    }
return (
<div className="navbar-parent dashboard-nav-parent">
    <nav className="navbar navbar-expand-lg navbar-dark" style={{width: "80%",margin: "0 auto"}}>
        <NavLink className="navbar-brand" to="/dashboard">Tonmoy Chiran</NavLink>
        <button className="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent-333" aria-controls="navbarSupportedContent-333" aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent-333">
            <ul className="navbar-nav ml-auto nav-inline-icons">
                <li className="nav-item">
                    <NavLink className="nav-link" exact activeClassName="active-nav" to="/dashboard/setting">
                        <span><MdSettings className="icon"/></span>
                    </NavLink>
                </li>
                <li className="nav-item">
                    <a onClick={logOut} className="nav-link"><span><FiLogOut className="icon"/></span></a>
                    {/* <NavLink className="nav-link" exact activeClassName="active-nav" to="/logout">
                        <span><FiLogOut className="icon"/></span>
                    </NavLink> */}
                </li>
            </ul>
        </div>
    </nav>
</div>

);
}

export default DashboardNavbar;